// extracted by mini-css-extract-plugin
module.exports = {"container":"days-remaining_container__NI-Ct"};